export default {
  path: '',
  component: () => import(`@/page/distributor/component/basic-layout/1.0.4/index.vue`),
  children: [
    {
      path: '/distributor/tour/back',
      component: () => import('@/page/distributor/component/admin-layout/index.vue'),
      children: [
        {
          path: '/distributor/tour/back/add-staff',
          name: 'distributor-tour-back-add-staff',
          component: () => import('@/page/distributor/tour/back/personal-center/add-staff/index.vue'),
          meta: {
            nav_list_for_admin_layout_head_nav: [
              {name: `个人中心`},
              {name: `员工添加`},
            ],
          },
        },
      ]
    },
  ]
};
